module.exports = __webpack_public_path__ + "spotlight3.070d8e542114454bad4cf6191c933034.png";